import React from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, Tooltip } from "@mui/material";
import { IconEye } from "@tabler/icons-react";
import { EditButton } from "components/ui/buttons/StyledButtons";
import { useTheme } from "@mui/material/styles";
import AttendanceStatusChip from "components/attendances/AttendanceStatusChip";
import { formatAttendanceDateTime, formatCpf } from "utils/attendance";
import CustomerNameButton from "components/customer360/CustomerNameButton";

const AttendanceTable = ({ attendances, onView, selectedId = null }) => {
  const theme = useTheme();
  const stickyCellBg = theme.palette.background.paper;
  const rowSelectedBg = theme.palette.secondary.light;
  const rowHoverBg = `color-mix(in srgb, ${theme.palette.secondary.main} 12%, ${stickyCellBg})`;

  const handleRowClick = (event, attendance) => {
    if (event.target.closest("button, input, a, [role='button']")) return;
    onView(attendance);
  };

  return (
    <Table sx={{ minWidth: 1400 }}>
      <TableHead>
        <TableRow>
          <TableCell>Identificador</TableCell>
          <TableCell>Nome do cliente</TableCell>
          <TableCell>CPF</TableCell>
          <TableCell>Nº Processo</TableCell>
          <TableCell>Assunto</TableCell>
          <TableCell>Consultor</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Último atendimento</TableCell>
          <TableCell>Descrição</TableCell>
          <TableCell
            align="right"
            sx={{ position: "sticky", right: 0, backgroundColor: stickyCellBg, zIndex: 1 }}
          >
            Ações
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {attendances.map((attendance) => {
          const isHighlighted = selectedId === attendance.id;
          const lastUser = attendance.last_interaction_user_name || "";
          const lastAt = attendance.last_interaction_at
            ? `${formatAttendanceDateTime(attendance.last_interaction_at)}${lastUser ? ` - ${lastUser}` : ""}`
            : "";
          const excerpt = attendance.last_interaction_excerpt || "";

          return (
            <TableRow
              key={attendance.id}
              onClick={(event) => handleRowClick(event, attendance)}
              sx={{
                cursor: "pointer",
                backgroundColor: isHighlighted ? rowSelectedBg : undefined,
                "&:hover": {
                  backgroundColor: isHighlighted ? rowSelectedBg : rowHoverBg,
                },
                "&:hover .attendances-table-actions-cell": {
                  backgroundColor: isHighlighted ? rowSelectedBg : rowHoverBg,
                },
              }}
            >
              <TableCell sx={{ whiteSpace: "nowrap" }}>{attendance.identifier}</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <CustomerNameButton customerId={attendance.customer}>
                  {attendance.customer_name || ""}
                </CustomerNameButton>
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {attendance.customer_cpf ? formatCpf(attendance.customer_cpf) : ""}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>{attendance.process_number || ""}</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {attendance.subject_display || attendance.subject || ""}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>{attendance.sales_consultant_name || ""}</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <AttendanceStatusChip
                  status={attendance.status}
                  label={attendance.status_display}
                />
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>{lastAt}</TableCell>
              <TableCell sx={{ maxWidth: 280 }}>
                <Tooltip title={excerpt} disableHoverListener={!excerpt}>
                  <span
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {excerpt}
                  </span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="attendances-table-actions-cell"
                align="right"
                sx={{
                  position: "sticky",
                  right: 0,
                  zIndex: 1,
                  backgroundColor: isHighlighted ? rowSelectedBg : stickyCellBg,
                  minWidth: 80,
                }}
              >
                <Tooltip title="Ver detalhes">
                  <EditButton onClick={() => onView(attendance)}>
                    <IconEye stroke={1.5} size="1.3rem" />
                  </EditButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default AttendanceTable;
